import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Redireccion, cuentaCliente } from "../Rutas/Servicios";
import { Get, GetSinRetorno } from "../Rutas/ApiRest";
import { tokens } from "../Context/Tokens";
import { RespuestaInicial, RespuestaLoginDTO } from "../Model/RespuestaLoginDTO";
import { Contexto } from "../Context/Contexto";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { CookiesProvider, useCookies } from 'react-cookie'
import { encryptAES } from "../Componentes/encriptacion";


export default function RegistroPagina()
{
    const {tok}=useContext(tokens)
    let { id,casilla } = useParams();
    const [Respuesta,SetRespuesta]=useState<RespuestaLoginDTO>(RespuestaInicial)
    const {SetMensajeEmergente}=useContext(MensajeContActualizacion)
    const {toggleTodo}=useContext(tokens)
    const [cookies, setCookie,removeCookie] = useCookies(['rutcli','mensaje'])
    const respuestaGoogle=(respuestas:any)=>
    {
      toggleTodo();
        var datos=""
        var casilla2=""
        if(id!=null)
        {
            datos=id
        }
        if(casilla!=null)
        {
          casilla2=casilla
        }
        localStorage.setItem('source',datos)
        localStorage.setItem('asillatemporal',casilla2)
        const dato=GetSinRetorno(cuentaCliente.AumentoGoogle,"application/json",tok)
        deco(respuestas.credential)
        
        
    }
    const deco=(token:string)=>
    {
     
      
       const parts=token.split(".");
       if(parts.length==3)
       {
        
        const email=JSON.parse(atob(parts[1]))
        localStorage.setItem('nombre',email.given_name)
        localStorage.setItem('apellido',email.family_name)
        localStorage.setItem('email',email.email)
        if(email.email_verified)
        {
          Activador2(email.email)
        }
       }
    }
    const Activador2=(correo:string)=>
    {
      const verificar=Get(cuentaCliente.InicioGoogle.replace("@email",correo),"application/json","")
      verificar.then(resultado=>{

        setCookie('rutcli',encryptAES(resultado.RutCli,process.env.REACT_APP_API_KEY),{domain:".eshopex.cl"})
        SetRespuesta(resultado)

      }
      )
    }

    useEffect(()=>
    {
      if(Respuesta!=RespuestaInicial)
      {
        console.log(Respuesta)
        if(Respuesta.valido==0)
        {
          
          if (Respuesta.Mensaje.includes("registrado en nuestros datos"))
          {
            window.open(Redireccion.datosExtraGoogle,"_top")
          }else
          {
            localStorage.clear();
            
          }
          
          
        }else
        {
          if(Respuesta.RutCli>0)
          {
            removeCookie("rutcli")
            removeCookie("mensaje")
            setCookie('rutcli',encryptAES(Respuesta.RutCli,process.env.REACT_APP_API_KEY),{domain:".eshopex.cl"})
            setCookie('mensaje', "Mandado") 
            window.open(Redireccion.login,"_top")
          }
        }
      }
    },[Respuesta])
    return(
    <>
    

    <div className="card-body">
                <div className="pt-4 pb-2">
                  <h5 className="text-center pb-0 fs-4">Crea tu cuenta con google</h5>
                </div>
    </div>
    <div className="col-12" style={{alignItems:"center",justifyContent:"center",display:"flex" }}> <GoogleOAuthProvider
        clientId="671055403996-n0p3q6ia2u5dq98glnodrtib1sp1qkud.apps.googleusercontent.com">

        <GoogleLogin onSuccess={respuestaGoogle} ></GoogleLogin>
    </GoogleOAuthProvider></div>
    
        
  
    
    
    
    </>)
}